import Cookies from 'universal-cookie';
import jwt from 'jsonwebtoken';
import { decrypt } from './decryptor';

export default function isEligible(id) {
  const cookies = new Cookies();

  if (cookies.get('token')) {
    const user = jwt.decode(decrypt(cookies.get('token')));
    const role = user?.attributes?.role;

    let eligible = false;

    if (id === 'data_permohonan') {
      if (['admin_opd'].includes(role)) eligible = true;
    }

    if (id === 'add_superadmin') {
      if (['superadmin'].includes(role)) eligible = true;
    }

    if (id === 'approve_data_permohonan') {
      if (['admin', 'superadmin'].includes(role)) eligible = true;
    }

    if (id === 'data_permohonan_approval') {
      if (['admin', 'superadmin'].includes(role)) eligible = true;
    }

    if (id === 'kategori_se') {
      if (['admin_opd'].includes(role)) eligible = true;
    }

    if (id === 'feedback') {
      if (['admin', 'superadmin'].includes(role)) eligible = true;
    }

    if (id === 'feedback_form') {
      if (['admin', 'superadmin', 'admin_guest'].includes(role)) eligible = true;
    }

    if (id === 'feedback_result') {
      if (['admin_opd'].includes(role)) eligible = true;
    }

    if (id === 'delete_user') {
      if (['superadmin'].includes(role)) eligible = true;
    }

    if (id === 'delete_uat') {
      if (['superadmin', 'admin', 'admin_opd', 'developer'].includes(role)) eligible = true;
    }

    if (id === 'delete_app') {
      if (['superadmin', 'admin', 'admin_opd', 'developer'].includes(role)) eligible = true;
    }

    if (id === 'delete_token') {
      if (['superadmin', 'admin'].includes(role)) eligible = true;
    }

    // widget
    if (id === 'tambah_layanan') {
      if (['admin_opd'].includes(role)) eligible = true;
    }

    if (id === 'activity_widget') {
      if (['admin_opd'].includes(role)) eligible = true;
    }

    if (id === 'check_rekomendasi') {
      if (['admin', 'superadmin'].includes(role)) eligible = true;
    }

    if (id === 'pilih_instansi') {
      if (['admin', 'superadmin', 'admin_guest'].includes(role)) eligible = true;
    }

    // button
    if (id === 'hapus_layanan') {
      if (['admin_opd', 'admin', 'superadmin'].includes(role)) eligible = true;
    }

    if (id === 'pemenuhan_rekomendasi') {
      if (['admin_opd', 'admin', 'superadmin'].includes(role)) eligible = true;
    }

    if (id === 'revisi_permohonan') {
      if (['admin_opd'].includes(role)) eligible = true;
    }

    if (id === 'update_feedback') {
      if (['superadmin', 'admin', 'admin_opd'].includes(role)) eligible = true;
    }

    // pages

    if (id === 'page_requests') {
      if (['admin_opd'].includes(role)) eligible = true;
    }

    if (id === 'page_app') {
      if (['superadmin', 'admin', 'admin_opd', 'developer'].includes(role)) eligible = true;
    }

    if (id === 'page_uat') {
      if (['superadmin', 'admin', 'admin_opd', 'developer'].includes(role)) eligible = true;
    }

    if (id === 'page_user') {
      if (['superadmin', 'admin'].includes(role)) eligible = true;
    }

    if (id === 'page_token') {
      if (['superadmin', 'admin'].includes(role)) eligible = true;
    }

    if (id === 'page_report_rekomendasi') {
      if (['superadmin', 'admin', 'admin_guest'].includes(role)) eligible = true;
    }

    if (id === 'page_setting') {
      if (['superadmin', 'admin'].includes(role)) eligible = true;
    }

    return eligible;
  }
}
